import { productFamilyCodes } from 'types/productFamilyCodes';

const getFareTypeValues = (user, fareType) => {
  const { salesChannel } = user;
  const isEuroStar = salesChannel.toLowerCase() === 'eurostar';
  let productFamilies;
  let contractCode;
  const productFamilyByFareType = {
    B_FORCE: productFamilyCodes.BORDER_FORCE,
    BLUE_VOUCH: productFamilyCodes.BLUE_VOUCHER,
    BSG1: productFamilyCodes.BSG,
    BSG2: productFamilyCodes.BSG,
    BSG3: productFamilyCodes.BSG,
    BSG4: productFamilyCodes.BSG,
    CHART: productFamilyCodes.CHARTER,
    CONTRACTOR: productFamilyCodes.CONTRACTOR,
    CTOLL: productFamilyCodes.CHARTER_TOLLABLE,
    DUTY_TOLL: productFamilyCodes.DUTY_TOLLABLE,
    DUTY: productFamilyCodes.DUTY_NON_TOLLABLE,
    EDUCATION: productFamilyCodes.EDUCATION,
    FIP_E: productFamilyCodes.FIP_E,
    FIP_I: productFamilyCodes.FIP_I,
    GROUP: productFamilyCodes.GROUP,
    INVIT: productFamilyCodes.INVITATION,
    IRAIL: productFamilyCodes.INTER_RAIL,
    LMDC_PUB: productFamilyCodes.LAST_MINUTE_PUBLIC,
    LMDC_RIT: productFamilyCodes.LAST_MINUTE_RIT,
    LOYALTY: productFamilyCodes.EUROSTAR_LOYALTY,
    RITSKI: productFamilyCodes.RIT,
    MAGICB_PUB: productFamilyCodes.MAGICBREAKS_PUBLIC,
    MAGICB_RIT: productFamilyCodes.MAGICBREAKS_RIT,
    MICE: productFamilyCodes.MICE,
    MOMENTUM: productFamilyCodes.MOMENTUM,
    OS_GROUP: productFamilyCodes.OSGRP,
    OS_RIT: productFamilyCodes.OSRIT,
    PALS: productFamilyCodes.PALS,
    PARTNER: productFamilyCodes.PARTNER,
    PUBLIC: productFamilyCodes.PUB,
    RAILTEAM: productFamilyCodes.RAILTEAM_REWARD,
    REWARD: productFamilyCodes.REWARD,
    RIT: productFamilyCodes.RIT,
    SNAP: productFamilyCodes.SNAP,
    SNCX: productFamilyCodes.SNCX,
    TFL: productFamilyCodes.TFL,
    TRIBE: productFamilyCodes.TRIBE,
    WD_PUB: productFamilyCodes.WALT_DISNEY_PUBLIC,
    WD_RIT: productFamilyCodes.WALT_DISNEY_RIT,
    RITPLUS: productFamilyCodes.RITPLUS,
    INSTBK_RIT: productFamilyCodes.INSTBK_RIT,
    VIP_RP: productFamilyCodes.VIP_RP,
    TEAMGB: productFamilyCodes.TEAMGB,
    TEAMNL: productFamilyCodes.TEAMNL,
    TEAMBE: productFamilyCodes.TEAMBE,
    TEAMDE: productFamilyCodes.TEAMDE,
    PARALYMPIC: productFamilyCodes.PARALYMPIC,
    PARALYMPIC_NL: productFamilyCodes.PARALYMPIC_NL,
    PARALYMPIC_BE: productFamilyCodes.PARALYMPIC_BE,
    MICEGROUP: productFamilyCodes.MICEGROUP,
    EX_CARRIAGE: productFamilyCodes.EX_CARRIAGE
  };

  if (!isEuroStar) {
    contractCode = fareType;
    productFamilies = [productFamilyByFareType[fareType] || 'CORP'];
  } else {
    productFamilies = [fareType];
    contractCode = 'EIL_ALL';
  }

  return { contractCode, productFamilies };
};

export { getFareTypeValues };
